import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "html-reference"
    }}>{`HTML Reference`}</h1>
    <p>{`Technical documentation regarding some of the HTML elements and attributes that are supported.`}</p>
    <h2 {...{
      "id": "pages-in-this-section"
    }}>{`Pages in this section`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "General/index.md"
        }}>{`General`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Hierarchy/index.md"
        }}>{`Hierarchy`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      